import { render, staticRenderFns } from "./GenericDeviceHistoryItem.vue?vue&type=template&id=5d028a64&scoped=true&"
import script from "./GenericDeviceHistoryItem.vue?vue&type=script&lang=ts&"
export * from "./GenericDeviceHistoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./GenericDeviceHistoryItem.vue?vue&type=style&index=0&id=5d028a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d028a64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VRow})
